var $ = require('jquery');
var moment = require('moment-timezone');
const { localeForMoment } = require('../../shared/helpers/Dates');

// load moment locales
require('moment/locale/fr');
require('moment/locale/es');
require('moment/locale/ko');
require('moment/locale/pl');
require('moment/locale/pt-br');
require('moment/locale/ru');
require('moment/locale/zh-cn');

// customize time formats
moment.updateLocale('en', {
  longDateFormat: {
    LT: 'h:mm A',
    LTS: 'h:mm:ss A',
    L: 'MM/DD/YYYY',
    LL: 'dddd MMMM D, YYYY',
    LLL: 'MMMM D, YYYY LT',
    LLLL: 'dddd, MMMM D, YYYY LT',
  },
});
moment.updateLocale('fr', {
  longDateFormat: {
    LT: 'HH[h]mm',
    LTS: 'LT:ss',
    L: 'DD/MM/YYYY',
    LL: 'dddd D MMMM, YYYY',
    LLL: 'D MMMM YYYY LT',
    LLLL: 'dddd D MMMM YYYY LT',
  },
});
moment.updateLocale('es', {
  longDateFormat: {
    LT: 'H:mm',
    LTS: 'H:mm:ss',
    L: 'DD/MM/YYYY',
    LL: 'D [de] MMMM [de] YYYY',
    LLL: 'D [de] MMMM [de] YYYY H:mm',
    LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
  },
});
moment.updateLocale('ko', {
  longDateFormat: {
    LT: 'A h:mm',
    LTS: 'A h:mm:ss',
    L: 'YYYY.MM.DD.',
    LL: 'YYYY년 MMMM D일',
    LLL: 'YYYY년 MMMM D일 A h:mm',
    LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
  },
});
moment.updateLocale('pl', {
  longDateFormat: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    L: 'DD.MM.YYYY',
    LL: 'D MMMM YYYY',
    LLL: 'D MMMM YYYY HH:mm',
    LLLL: 'dddd, D MMMM YYYY HH:mm',
  },
});
moment.updateLocale('pt', {
  longDateFormat: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    L: 'DD/MM/YYYY',
    LL: 'D [de] MMMM [de] YYYY',
    LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
    LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
  },
});
moment.updateLocale('ru', {
  longDateFormat: {
    LT: 'H:mm',
    LTS: 'H:mm:ss',
    L: 'DD.MM.YYYY',
    LL: 'D MMMM YYYY г.',
    LLL: 'D MMMM YYYY г., H:mm',
    LLLL: 'dddd, D MMMM YYYY г., H:mm',
  },
});
moment.updateLocale('zh', {
  longDateFormat: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    L: 'YYYY/MM/DD',
    LL: 'YYYY年M月D日',
    LLL: 'YYYY年M月D日Ah点mm分',
    LLLL: 'YYYY年M月D日ddddAh点mm分',
  },
});

const lang = $('html').attr('lang');
// set current locale
moment.locale(localeForMoment(lang));
